// the imports
import { React, useState, useEffect } from 'react';
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment'
import CalendarService from '../../../services/CalendarService';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Select from 'react-select'
import ClientService from "../../../services/ClientService";
import te from 'date-fns/esm/locale/te/index.js';
require('moment/locale/sr.js')



const MySwal = withReactContent(Swal)
const localizer = momentLocalizer(moment)

const MyCalendar = () => {

  const [minTime, setMinTime] = useState(CalendarService.getMinTime())
  const [maxTime, setMaxTime] = useState(CalendarService.getMaxTime())
  const [events, setEvents] = useState([])
  const [description, setDescription] = useState("")
  const [modifiedUserForSelect, setModifiedUserForSelect] = useState({})

  const [clientsData, setClientsData] = useState(null)


  const getClients = () => {
    ClientService.getClients().then((response) => {
      setClientsData(response.data)
    });
  };



  useEffect(() => {
    getClients()
    fetchSchedule()
  }, [])

  useEffect(() => {
    if (clientsData) {
      let userSelectData = clientsData.map(client => {
        client.value = client.name
        client.label = client.name
        return client
      })

      setModifiedUserForSelect(userSelectData)

    }
  }, [clientsData])

  const fetchSchedule = () => {
    CalendarService.getCalendar().then(response => {
      let data = response.data.map((temp) => {
        temp.title = temp.user;
        temp.start = new Date(temp.start);
        temp.end = new Date(temp.start);
        temp.end.setMinutes(temp.start.getMinutes() + temp.duration);
        return temp
      })

      setEvents(data)
    })
  }

  const deleteEvent = (event) => {
    CalendarService.deleteEvent(event.id).then(() => {
      fetchSchedule()
    })
  }

  const scheduleEvent = (event) => {
    CalendarService.addEvent(event).then(() => {
      fetchSchedule()
    })
  }

  const selectEvent = (event) => {
    MySwal.fire({
      title: event.description,
      showCancelButton: true,
      showDenyButton: true,
      showConfirmButton: false,
      denyButtonText: `Obriši`,
      cancelButtonText: `Otkaži`,
    }).then((result) => {
      if (result.isDenied) {
        deleteEvent(event)
      }
    })
  }

  const serviceOptions = [
    { value: 'Pregled Nova Pazova', label: 'Pregled Nova Pazova' },
    { value: 'Pregled Beograd', label: 'Pregled Beograd' },
    { value: 'Kontrola Beograd', label: 'Kontrola Beograd' },
    { value: 'Kontrola Nova Pazova', label: 'Kontrola Nova Pazova' },
  ]

  const durationOptions = [
    { value: 5, label: '5 min' },
    { value: 10, label: '10 min' },
    { value: 15, label: '15 min' },
    { value: 20, label: '20 min' },
    { value: 25, label: '25 min' },
    { value: 30, label: '30 min' },
    { value: 35, label: '35 min' },
    { value: 40, label: '40 min' },
    { value: 45, label: '45 min' },
    { value: 50, label: '50 min' },
    { value: 55, label: '55 min' },
    { value: 60, label: '60 min' },
  ]


  const selectSlot = (slot, event) => {
    setDescription("")
    let id = null
    let tempDesc = "";
    let service = "";
    let user = "";
    let duration = "0";
    if (event) {
      id = event.id
      slot.start = event.start
      service = serviceOptions.filter(el => el.value === event.service)
      tempDesc = event.description
      duration = durationOptions.filter(el => el.value === event.duration)
      user = event.user
    }
    let start = moment(slot.start).format("HH:mm:ss");
    MySwal.fire({
      title: '',
      html:
        <div className="text-left">
          <h3 className="text-center py-2 bg-bluePrimary text-white shadow-md font-medium  rounded-tr-[5px] rounded-tl-[5px]">Da li želite da zakažete sastanak?</h3>
          <div className="p-5">
            <span className='block text-center text-sm font-medium'>Vreme - {moment(slot.start).format("Do MMMM YYYY, HH:mm:ss a")}</span>
            <div className='mt-5'>
              <div className='mt-5'>
                <label className="font-medium text-xs text-gray-500">Novi korisnik</label>
                <input type="text" defaultValue={user} onChange={(e) => user = e.target.value} className="input-field" />
              </div>
              <div className="mt-5">
                <label className="font-medium text-xs text-gray-500">Korisnik</label>
                <Select
                  placeholder="Odaberi..."

                  onChange={(item) => { user = item.label; tempDesc = item.phoneNumber; }}
                  options={modifiedUserForSelect}
                  classNamePrefix='select'
                />
              </div>
              <div className='mt-5'>
                <label className="font-medium text-xs text-gray-500">Servis</label>
                <Select
                  placeholder="Odaberi..."

                  defaultValue={service}
                  onChange={(item) => {
                    service = item.value;
                  }}
                  options={serviceOptions}
                  classNamePrefix='select'
                />
              </div>
              <div className='mt-5'>
                <div>
                  <label className="font-medium text-xs text-gray-500">Start</label>
                  <input type="text" defaultValue={moment(slot.start).format("HH:mm:ss")} onChange={(e) => start = e.target.value} className="input-field" />
                </div>
                <div className='mt-5'>
                  <label className="font-medium text-xs text-gray-500">Vreme trajanja</label>
                  <Select
                    placeholder="Odaberi..."
                    defaultValue={duration}
                    onChange={(item) => {
                      duration = item.value;
                    }}
                    options={durationOptions}
                    classNamePrefix='select'
                  />
                </div>
              </div>
              <div className='mt-5'>
                <label className="font-medium text-xs text-gray-500">Kratak Opis</label>
                <textarea defaultValue={tempDesc} onChange={(e) => { tempDesc = e.target.value; }} className="input-field h-52" required>
                </textarea>
              </div>
            </div>
          </div>
        </div>,
      showCancelButton: true,
      showDenyButton: event ? true : false,
      confirmButtonText: 'Sačuvaj',
      denyButtonText: `Obriši`,
      cancelButtonText: `Nazad`,
    }).then((result) => {
      if (result.isConfirmed) {
        let startDatetime = slot.start.toISOString().split(".")[0];
        slot = {
          ...slot,
          'description': tempDesc,
          'start': startDatetime.replace(startDatetime.split("T")[1], start),
          'service': service instanceof Array ? service[0].value : service,
          'user': user,
          'duration': duration instanceof Array ? duration[0].value : duration,
        }
        if (id) {
          slot.id = id;
        }
        scheduleEvent(slot)
      } else if (result.isDenied) {
        deleteEvent(event)
      }
    })
  }

  const eventColors = (event) => {
    var backgroundColor = "event-";
    switch (event.service) {
      case 'Pregled Nova Pazova':
        event.color = "pink"; break;
      case 'Pregled Beograd':
        event.color = "azure"; break;
      case 'Kontrola Beograd':
        event.color = "orange"; break;
      case 'Kontrola Nova Pazova':
        event.color = "default"; break;
      default:
        event.color = "default"; break;
    }
    event.color
      ? (backgroundColor = backgroundColor + event.color)
      : (backgroundColor = backgroundColor + "red");
    return {
      className: backgroundColor,
    };
  }

  return (
    <BigCalendar
      selectable
      defaultView='week'
      min={minTime}
      max={maxTime}
      localizer={localizer}
      events={events}
      timeslots={1}
      step={60}
      onSelectEvent={(event) => { selectSlot({}, event) }}
      onSelectSlot={(slotInfo) => { selectSlot(slotInfo) }}
      startAccessor="start"
      endAccessor="end"
      eventPropGetter={eventColors}
      longPressThreshold={10}
      style={{ height: 500 }}
      messages={{
        month: 'Mesec',
        day: 'Dan',
        today: 'Danas',
        week: 'Nedelja',
        agenda: 'Program rada',
        next: 'Sledeći dan',
        previous: 'Prethodni dan'
      }}
    />
  )
}
export default MyCalendar;